var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_57_7640",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 12,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.96967 1.38886C1.26256 1.12038 1.73744 1.12038 2.03033 1.38886L11.0303 9.63887C11.3232 9.90735 11.3232 10.3427 11.0303 10.6111C10.7374 10.8796 10.2626 10.8796 9.96967 10.6111L0.96967 2.36114C0.676777 2.09265 0.676777 1.65735 0.96967 1.38886Z",
    fill: "#006FFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0303 1.38886C10.7374 1.12038 10.2626 1.12038 9.96967 1.38886L0.96967 9.63887C0.676777 9.90735 0.676777 10.3427 0.96967 10.6111C1.26256 10.8796 1.73744 10.8796 2.03033 10.6111L11.0303 2.36114C11.3232 2.09265 11.3232 1.65735 11.0303 1.38886Z",
    fill: "#006FFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_57_7640)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 12,
    height: 11,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErase);
export default __webpack_public_path__ + "static/media/erase.a65d647a120a3a10fdfe42b27def08db.svg";
export { ForwardRef as ReactComponent };